import { render } from "./TaskCloseCofirm.vue?vue&type=template&id=4ffcc6a8"
import script from "./TaskCloseCofirm.vue?vue&type=script&lang=js"
export * from "./TaskCloseCofirm.vue?vue&type=script&lang=js"

import "./TaskCloseCofirm.vue?vue&type=style&index=0&id=4ffcc6a8&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__